import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { isEmpty, intersection } from 'lodash';
import isPgPinNeeded from 'utils/is-pg-pin-needed';
import innerAnalyticsVolia from 'helpers/innerAnalyticsVolia';
import { selectParentalControlAge, selectIsParentalControlEnabled } from 'reducers/parental-lock/selectors';
import { CONTENT_TYPES } from 'constants/content-types';
import { MISSING_SUBSCRIPTION, NOT_AUTHENTICATED } from 'constants/visibility-types';
import { navigateToPlayerPage } from 'actions/player';
import useModals from 'hooks/useModals';
import { resolvePlayerNavLink } from 'helpers/urlhelper';
import { navigateToAuthPage, resetUserData } from 'actions/app';
import { getIsLifecellFlag } from 'reducers/profile/selectors';

export default () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const isLifecellUser = useSelector(getIsLifecellFlag);
  const isParentalEnabled = useSelector(selectIsParentalControlEnabled);
  const age = useSelector(selectParentalControlAge);
  const { showEnterPinModal, showLifecellPaymentModal } = useModals();

  const onEnter = useCallback(
    (item, focusBackConfig, analyticsParams) => {
      const { visibilityDetails } = item;
      const id = item.targetId || item.id;
      const goToPlayer = () => dispatch(navigateToPlayerPage({ item }));

      const addInfo = `vod_asset_id=${id};channel_id=null;content_type=EPISODE|MOVIE;type=TV_SERIES;epgEventState=null`;

      if (analyticsParams) innerAnalyticsVolia.postEvent({ ...analyticsParams, addInfo });

      if (visibilityDetails === NOT_AUTHENTICATED) {
        const search = `?vodAssetId=${id}&onSuccess=${history.location.pathname}`;
        dispatch(navigateToAuthPage(search));
        return;
      }
      if (visibilityDetails === MISSING_SUBSCRIPTION) {
        // If the object is sold by the piece, then need to go to the tariffs page
        const isSinglePurchase = !isEmpty(intersection(item.types, ['EST', 'TVOD']));

        if (isSinglePurchase) {
          history.push(`/details/${CONTENT_TYPES.TV_SERIES}/${item.metadata.tvSeriesId}/tariffs`);
        } else {
          const onSuccess = resolvePlayerNavLink(item);

          if (isLifecellUser) {
            // Hack while we don't have react-query flow
            const onSuccess = async () => {
              await dispatch(resetUserData());
              history.goBack();
            };
            showLifecellPaymentModal(
              {
                id: id,
                assetType: 'vodAssetId',
                onSuccess,
              },
              focusBackConfig,
            );
            return;
          }
          return history.push({
            pathname: '/profile/packages/filter',
            search: `?vodAssetId=${id}&onSuccess=${onSuccess}`,
          });
        }
        return;
      }

      if (isParentalEnabled && isPgPinNeeded(item.pgRating, age)) {
        return showEnterPinModal(focusBackConfig, goToPlayer);
      }
      goToPlayer();
    },
    [age, dispatch, history, isLifecellUser, isParentalEnabled, showEnterPinModal, showLifecellPaymentModal],
  );

  return onEnter;
};
